import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, X } from 'lucide-react';
import { directionForLanguage } from '../../i18n/config';
import './AnalyzeAgainModal.css';
import './ReviewRequiredModal.css';

interface ReviewRequiredModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ReviewRequiredModal: React.FC<ReviewRequiredModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
}) => {
  const { t, i18n } = useTranslation('taskpane');
  const chromeDir = directionForLanguage(i18n.language);

  React.useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div
      className="aa-modal-backdrop"
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget) onCancel();
      }}
    >
      <div
        className="aa-modal review-required-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="review-required-modal-title"
        dir={chromeDir}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="aa-modal-header">
          <div className="aa-modal-icon-wrap" aria-hidden>
            <Users className="aa-icon-md aa-icon-blue" />
          </div>
          <div className="aa-modal-header-text">
            <h2 id="review-required-modal-title" className="aa-modal-title">
              {t('review.requiredModal.title')}
            </h2>
          </div>
          <button
            type="button"
            className="aa-modal-close"
            onClick={onCancel}
            aria-label={t('review.requiredModal.cancel')}
          >
            <X className="aa-icon-sm" />
          </button>
        </div>

        <div className="review-required-modal-body">
          <p>{t('review.requiredModal.p1')}</p>
          <p>{t('review.requiredModal.p2')}</p>
        </div>

        <div className="aa-modal-actions">
          <button type="button" className="aa-btn-secondary" onClick={onCancel}>
            {t('review.requiredModal.cancel')}
          </button>
          <button type="button" className="aa-btn-primary" onClick={onConfirm}>
            {t('review.requiredModal.goToReview')}
          </button>
        </div>
      </div>
    </div>
  );
};
